import PropTypes from "prop-types";
import React from "react";
import { Button, Upload01 } from "@opendate-app/setlist";

import CSVImporter from "./CSVImporter";

const PROMO_CODE_CSV_IMPORTER_KEY = "fd2c9b57-5d2f-4c70-a035-66b3b31c8b51";

const PromoCodeCSVImportButton = ({
  csrfToken,
  team,
  calendarEventId,
  onClose,
  className,
}) => (
  <CSVImporter
    csrfToken={csrfToken}
    team={team}
    importerKey={PROMO_CODE_CSV_IMPORTER_KEY}
    type="CSVImportRows::PromoCode"
    additionalParams={calendarEventId ? { calendar_event_id: calendarEventId } : {}}
    onClose={onClose}
    renderAnchor={(openModal) => (
      <Button variant="secondary" size="sm" icon={Upload01} className={className} onClick={openModal}>
        Import CSV
      </Button>
    )}
  />
);

PromoCodeCSVImportButton.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  calendarEventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func,
  className: PropTypes.string,
};

export default PromoCodeCSVImportButton;
